export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://allchinabuyspread.cc').replace(
  /\/$/,
  '',
);

export const SITE_NAME = 'AllChinaBuy Spreadsheet Hub';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';